export const Department: string[] = [ 
    'Accounts',
    'Business Development',
    'CAE',
    'Design',
    'Design and Development',
    'HR',
    'IT',
    'Management',
    'Admin',
    'QA',
    'Knowledge Management'
]